import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';
import { authHeaders, Badge, StatusBadge, PriorityBadge } from '../../CaseClient';

// Granular Add-Task widget — small "this task will be launched on case
// CASE-1234 / Title" header so a worker double-checks they're attaching
// the task to the right case before clicking Launch. The modal-host puts
// the bare {id} on ctx.case; the widget GETs the full case row so it can
// render title + status / priority badges.

function AddTaskCaseSummary() {
  const { token, workspaceId, case: hint } = useLayoutCtx();
  const caseId = hint?.id || null;
  const [row, setRow] = useState(hint && (hint.title || hint.case_number) ? hint : null);

  useEffect(() => {
    if (!caseId || !workspaceId) return;
    if (row && row.id === caseId && (row.title || row.case_number)) return;
    let cancelled = false;
    axios.get(
      `${API_BASE_URL}/api/casematrix/workspaces/${workspaceId}/cases/${caseId}`,
      { headers: authHeaders(token) },
    )
      .then(r => { if (!cancelled) setRow(r.data); })
      .catch(() => { /* leave row at the hint */ });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseId, workspaceId, token]);

  if (!caseId) return null;

  if (!row || (!row.title && !row.case_number)) {
    return (
      <div style={{ padding: '8px 12px', color: 'var(--text-secondary)', fontSize: '12px' }}>
        Loading case…
      </div>
    );
  }

  return (
    <div style={{
      background: 'var(--bg-tertiary)',
      border: '1px solid var(--border-color)',
      borderRadius: '6px',
      padding: '10px 12px',
      marginBottom: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    }}>
      <div style={{ fontSize: '10px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-secondary)' }}>
        Launching on case
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <span style={{ fontFamily: 'monospace', fontSize: '12px', color: 'var(--text-secondary)' }}>
          {row.case_number || (row.id || '').slice(0, 8)}
        </span>
        <span style={{ fontWeight: 600, fontSize: '13px' }}>{row.title || '(untitled)'}</span>
      </div>
      <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
        {row.status && <StatusBadge status={row.status} />}
        {row.priority && <PriorityBadge priority={row.priority} />}
        {row.case_type?.name && (
          <Badge color="#8b5cf6">{row.case_type.icon || '📋'} {row.case_type.name}</Badge>
        )}
      </div>
    </div>
  );
}

registerWidget({
  type: 'add_task.case_summary',
  categories: ['add_task'],
  palette_label: 'Parent case summary',
  description: 'Confirms which case the task is being launched on (number / title / status badges). Read-only.',
  Component: AddTaskCaseSummary,
  configSchema: null,
  publishes: [],
  subscribes: [],
  group: 'Add Task',
});
